export default "<div class=\"container-fluid\">\r\n  <div class=\"row m-5\">\r\n    <h1>Supervisor content goes here</h1>\r\n  </div>\r\n</div>\r\n\r\n";